import React, { memo, forwardRef } from "react";
const SvgPowerset = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M4.26 8.8v4.58h2.1c2.2 0 3.3-.773 3.3-2.32 0-1.507-1.087-2.26-3.26-2.26H4.26zm-.8-1.68H6.6c1.587 0 2.827.327 3.72.98.893.64 1.34 1.627 1.34 2.96 0 1.36-.473 2.367-1.42 3.02-.933.653-2.18.98-3.74.98H4.26v5.26c0 .413-.107.707-.32.88-.213.16-.433.24-.66.24-.24 0-.467-.08-.68-.24-.213-.173-.32-.467-.32-.88V8.3c0-.787.393-1.18 1.18-1.18zM13.815 20a15.086 15.086 0 01-.68-4.48c0-1.52.226-3.007.68-4.46.466-1.467 1.093-2.78 1.88-3.94.226-.32.48-.48.76-.48.226 0 .413.073.56.22.146.147.22.333.22.56 0 .2-.06.387-.18.56-1.48 2.4-2.22 4.913-2.22 7.54s.74 5.14 2.22 7.54c.12.187.18.373.18.56a.759.759 0 01-.22.56.759.759 0 01-.56.22c-.28 0-.534-.16-.76-.48-.787-1.16-1.414-2.467-1.88-3.92zM28.683 11.06c.467 1.453.7 2.94.7 4.46s-.233 3.013-.7 4.48c-.453 1.453-1.073 2.76-1.86 3.92-.213.32-.46.48-.74.48a.828.828 0 01-.58-.22.758.758 0 01-.22-.56c0-.2.06-.387.18-.56 1.48-2.4 2.22-4.913 2.22-7.54s-.74-5.14-2.22-7.54a1.029 1.029 0 01-.18-.56c0-.227.073-.413.22-.56a.828.828 0 01.58-.22c.28 0 .527.16.74.48.787 1.16 1.407 2.473 1.86 3.94z"
      />
      <rect width={8} height={13} x={17.56} y={9.28} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgPowerset.displayName = "SvgPowerset";
const MemoForwardRef = memo(SvgPowerset);
export default MemoForwardRef;
